const LessonEntryHelpModal = () => {
  return (
    <div className='px-6 pb-6'>
      <h2 className='text-2xl font-semibold text-gray-800 mb-4 text-center'>
        Lesson Entries Screen Help
      </h2>
      <div className='space-y-6 max-h-[70vh] overflow-y-auto pr-2'>
        <div>
          <span className='text-lg font-semibold text-blue-600'>
            You initially have 2 options on this screen
          </span>
          <ul className='list-disc ml-8 mt-2 text-slate-700'>
            <li>
              <span className='text-blue-600 font-medium'>
                Move Lessons from the Roster
              </span>
            </li>
            <li>
              <span className='text-blue-600 font-medium'>
                Edit Lesson entries already moved
              </span>
            </li>
          </ul>
        </div>
        <div>
          <span className='text-lg font-semibold text-green-700'>
            Working with the Roster Schedule
          </span>
          <ul className='list-disc ml-8 mt-2 text-slate-700 space-y-1'>
            <li>Information is from the Roster table</li>
            <li>
              Lesson Prices and Instructor Rates are obtained from the Current
              Ski Package and Level Rates tables
            </li>
            <li>
              You can change the following: Name, Lesson, # Students, Payment
              Method, Hotel and Gross
            </li>
            <li>
              If you can change the Ski Package or # Students
              <ul className='list-disc ml-8'>
                <li>
                  <span className='text-gray-600'>
                    Lesson Price is obtained from the Current Ski Package table
                  </span>
                </li>
                <li>
                  <span className='text-gray-600'>
                    Instructor Rate is obtained from the Current Level Rates
                    table
                  </span>
                </li>
              </ul>
            </li>
            <li>
              Instructor Rates are initially pulled from the Roster record
            </li>
            <li>
              When the Lesson or # Students is changed the Instructor rate
              displayed will change accordingly
            </li>
            <li>
              Selection of a Hotel will change the Commission and the Net will
              change based on the Current percentage in the Hotel table
            </li>
            <li>
              Add Lesson button will add a Record to the Lesson Entries table
              and remove it from the current screen
              <ul className='list-disc ml-8'>
                <li>
                  <span className='text-gray-600'>
                    The Roster record will no longer be editable
                  </span>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div>
          <span className='text-lg font-semibold text-green-700'>
            Working with the Lesson Entries
          </span>
          <ul className='list-disc ml-8 mt-2 text-slate-700 space-y-1'>
            <li>Information is from the Lesson Entries table</li>
            <li>
              Lesson Prices and Instructor Rates are obtained from the Level
              Rates table that was Current when the Lesson was put into the
              Lesson Entries table
            </li>
            <li>
              You can change the following: Name, Lesson, # Students, Payment
              Method and Hotel
            </li>
            <li>
              If you can change the Ski Package or # Students
              <ul className='list-disc ml-8'>
                <li>
                  <span className='text-gray-600'>
                    Lesson Price is obtained from the Ski Package that was
                    Current when the Lesson was added
                  </span>
                </li>
                <li>
                  <span className='text-gray-600'>
                    Instructor Rate is obtained from the Level Rates Current
                    when the Lesson was added
                  </span>
                </li>
              </ul>
            </li>
            <li>
              When the Lesson or # Students is changed the Instructor rate
              displayed will change accordingly
            </li>
            <li>
              Selection of a Hotel will change the Commission and the Net will
              change based on the Current percentage in the Hotel table
            </li>
            <li>Update Lesson will only Update the Lesson Entry</li>
            <li>
              You can Remove a Lesson from the Lesson Entries table and it will
              then be available again in the Roster Schedule
              <ul className='list-disc ml-8'>
                <li>
                  <span className='text-gray-600'>
                    Remember that the Level Rates, Ski Package Fees or Hotel
                    Commission rates are saved with each Lesson Entry
                  </span>
                </li>
                <li>
                  <span className='text-gray-600'>
                    If these Rates and Fees were not correct when you put it in
                    the Lesson Entries table, simply Remove it and Add it again
                    with the Corrected Fees and Rates
                  </span>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default LessonEntryHelpModal;
